/**
 * @generated SignedSource<<a72f2dfbeaf5bec578f20cfd18611bfb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useMentionTrigger_OrganizationQuery$variables = {
  id: string;
};
export type useMentionTrigger_OrganizationQuery$data = {
  readonly organization: {
    readonly viewerCanUseChannelMention?: boolean;
  } | null;
};
export type useMentionTrigger_OrganizationQuery = {
  response: useMentionTrigger_OrganizationQuery$data;
  variables: useMentionTrigger_OrganizationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUseChannelMention",
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useMentionTrigger_OrganizationQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useMentionTrigger_OrganizationQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3c994a46343ef603eccc36d4b7af45ac",
    "id": null,
    "metadata": {},
    "name": "useMentionTrigger_OrganizationQuery",
    "operationKind": "query",
    "text": "query useMentionTrigger_OrganizationQuery(\n  $id: ID!\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      viewerCanUseChannelMention\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f60c49bedcf454218732c94db3ab195";

export default node;
